import React, { useState } from "react";
import ListingImageGrid from "./ListingImageGrid";
import { Container, Row, Col } from "react-bootstrap";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import CategoryIcon from "@mui/icons-material/Category";
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import LandscapeIcon from "@mui/icons-material/Landscape";
import ShareIcon from "@mui/icons-material/Share";
import FavoriteIcon from '@mui/icons-material/Favorite';
import DirectionsIcon from '@mui/icons-material/Directions';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import PropertyInformation from "./PropertyInformation";
import PriceHistory from "../components/PriceHistory";
import AffordabilityCalculator from "../components/AffordabilityCalculator";
import PropertyTaxInformation from "../components/PropertyTaxInformation";
import RelatedHomes from "../components/RelatedHomes";
import NearbyListings from "../components/NearbyListings";
import TalkToAgentSection from "../components/TalkToAgentSection";
import ListingContactAgent from "../components/ListingContactAgent";
import HomeValuesChart from "../components/HomeValuesChart";
import MightAlsoLike from "../components/MightLikeListings";
import SeoFooter from "../components/SeoFooter";

const images = [
    "https://ssl.cdn-redfin.com/photo/68/bigphoto/914/12364914_0.jpg",
    "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_3_0.jpg",
    "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_11_0.jpg",
    "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_6_0.jpg",
    "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_9_0.jpg"
];

export default function ListingDetails({ navbarHeight = 0 }) {

    function Description({ text }) {
        const [expanded, setExpanded] = useState(false);
        const charLimit = 420;

        const getTruncatedText = (str, limit) => {
            if (str.length <= limit) return str;
            const truncated = str.slice(0, limit);
            const lastSpace = truncated.lastIndexOf(" ");
            return truncated.slice(0, lastSpace) + "...";
        };

        const isLong = text.length > charLimit;
        const displayText = expanded || !isLong ? text : getTruncatedText(text, charLimit);

        return (
            <div>
                <p>{displayText}</p>
                {isLong && (
                    <span
                        style={{ color: "#007bff", cursor: "pointer" }}
                        onClick={() => setExpanded(!expanded)}
                    >
                        {expanded ? "Show less" : "Show more"}
                    </span>
                )}
            </div>
        );
    }


    return (
        <>
            <div style={{margin: "15px"}}>
                <a href="#" style={{ fontSize: "14px", color: "#007bff", textDecoration: "none", marginRight: "10px" }}>
                    &lt; Back to search
                </a>
                <span style={{ fontSize: "14px", color: "#6c757d" }}>
                    Home &gt; IL &gt; CHICAGO &gt; 60656 &gt; 8712 W BERWYN AVE UNIT 3W
                </span>
            </div>
            <ListingImageGrid images={images} />

            <div className="container mt-4 mb-4">
                <div className="row">
                    {/* Left Column */}
                    <div className="col-md-9">
                        <div>
                            <Container>
                                <Row>
                                    <Col lg={8}>
                                        <Row>
                                            <Col lg={3}>
                                                <div className="d-flex align-items-center mb-2">
                                                    <FiberManualRecordIcon style={{ color: "green", fontSize: 16, marginRight: 6 }} />
                                                    <span style={{ fontWeight: 500 }}>House For Sale</span>
                                                </div>
                                                <h2><b>$299,900</b></h2>
                                            </Col>
                                            <Col lg={9} className="text-end">
                                                <button className="btn ">
                                                    <DirectionsIcon style={{ marginRight: 6, verticalAlign: "middle" }} />
                                                    Directions
                                                </button>
                                                <button className="btn ">
                                                    <AttachEmailIcon style={{ marginRight: 6, verticalAlign: "middle" }} />
                                                    Share
                                                </button>
                                                <button className="btn ">
                                                    <FavoriteIcon style={{ marginRight: 6, verticalAlign: "middle" }} />
                                                    Save
                                                </button>

                                            </Col>

                                            <Col lg={12}>
                                                <h2>605 Keep Ave, Elgin, IL 60120</h2>
                                            </Col>
                                        </Row>

                                        <Description
                                            text={`Welcome to this delightful four-bedroom, two-bathroom home situated in a sought-after Elgin location! As you enter, you'll immediately appreciate the beautiful hardwood floors that extend throughout the entire house. The kitchen is a standout feature, offering a fantastic space for cooking and entertaining.
                                                    Each of the four bedrooms is generously sized, providing plenty of space for relaxation and personalization.
                                                    Lots of recent updates include new paint and flooring throughout, new deck, new roof within the last 5 years, and new AC within the last 4 years!
                                                    With its great location and ample space, this property is an ideal choice for a growing family, first-time homebuyers, or savvy investors looking for a strong rental opportunity.
                                                    Come and experience all this wonderful home has to offer! Sold AS-IS.`}
                                        />


                                    </Col>
                                    <Col lg={4}>

                                        <Row>
                                            <Col lg={4}>
                                                <h2>4</h2> <strong>Beds</strong>
                                            </Col>
                                            <Col lg={4}>
                                                <h2>2.5</h2> <strong>Baths</strong>
                                            </Col>
                                            <Col lg={4}>
                                                <h2>1,942</h2> <strong> Sq Ft</strong>
                                            </Col>
                                            <Col lg={12}>
                                                <Row>
                                                    <Col md={12}>
                                                        <div className="bg-light p-2 d-flex align-items-center justify-content-start mt-4 ">
                                                            <CalendarTodayIcon style={{ fontSize: 18, marginRight: 6 }} />
                                                            <b>2 Days&nbsp;</b> On Market
                                                        </div>
                                                    </Col>
                                                    <Col md={12}>
                                                        <div className="bg-light p-2 d-flex align-items-center justify-content-start mt-1">
                                                            <HomeWorkIcon style={{ fontSize: 18, marginRight: 6 }} />
                                                            Built <b>&nbsp;1933</b>
                                                        </div>
                                                    </Col>
                                                    <Col md={12}>
                                                        <div className="bg-light p-2 d-flex align-items-center justify-content-start mt-1">
                                                            <CategoryIcon style={{ fontSize: 18, marginRight: 6 }} />
                                                            <b>Single Family Home</b>
                                                        </div>
                                                    </Col>
                                                    <Col md={12}>
                                                        <div className="bg-light p-2 d-flex align-items-center justify-content-start mt-1">
                                                            <SquareFootIcon style={{ fontSize: 18, marginRight: 6 }} />
                                                            <b>$210</b>/sqft
                                                        </div>
                                                    </Col>
                                                    <Col md={12}>
                                                        <div className="bg-light p-2 d-flex align-items-center justify-content-start mt-1">
                                                            <LandscapeIcon style={{ fontSize: 18, marginRight: 6 }} />
                                                            <b>0.84&nbsp;</b> acre lot
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>


                                    </Col>
                                </Row>
                                <Row>

                                    <Col>
                                        <hr className="my-4" />
                                    </Col>

                                    <Col lg={12}>
                                        <div style={{ width: "100%", height: "300px" }}>
                                            <iframe
                                                title="Google Map"
                                                width="100%"
                                                height="100%"
                                                style={{ border: 0 }}
                                                loading="lazy"
                                                allowFullScreen
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3055.120816390657!2d-88.28532108461037!3d42.03336097920952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880f019f6f946d05%3A0xf6513db5e14ea58e!2s605%20Keep%20Ave%2C%20Elgin%2C%20IL%2060120%2C%20USA!5e0!3m2!1sen!2sus!4v1682303174534!5m2!1sen!2sus&maptype=satellite"
                                            ></iframe>
                                        </div>
                                    </Col>


                                    <Col lg={12}>
                                        <hr className="my-4" />
                                    </Col>

                                    <Col lg={12}>

                                        <PropertyInformation />

                                    </Col>


                                    <Col lg={12}>
                                        <PriceHistory />
                                    </Col>
                                    <Col lg={12}>
                                        <AffordabilityCalculator />
                                    </Col>
                                    <Col lg={12}>
                                        <PropertyTaxInformation />
                                    </Col>
                                    <Col lg={12}>
                                        <hr className="my-4" />
                                    </Col>

                                    <Col lg={12}>
                                        <RelatedHomes />
                                    </Col>

                                    <Col lg={12}>
                                        <hr className="my-4" />
                                    </Col>
                                    <Col lg={12}>
                                        <NearbyListings />
                                    </Col>

                                    <Col lg={12}>
                                        <HomeValuesChart />
                                    </Col>

                                    <Col lg={12}>
                                        <hr className="my-4" />
                                    </Col>

                                    <Col lg={12}>
                                        <ListingContactAgent />
                                    </Col>
                                    <Col lg={12}>
                                        <hr className="my-4" />
                                    </Col>

                                    <Col lg={12}>
                                        <MightAlsoLike />
                                    </Col>

                                </Row>

                            </Container>
                        </div>
                    </div>

                    {/* Right Column - Sticky with Offset */}
                    <div className="col-md-3 mb-4">
                        <div
                            style={{
                                position: "sticky",
                                top: `${navbarHeight + 20}px`
                            }}
                        >
                            <div style={{ borderRadius: "6px" }} className="p-3 border bg-light shadow-sm">
                                <div className="d-grid gap-2 mt-2">
                                    <h3 className="text-center">Tour This Property</h3>
                                    <button className="btn btn-primary btn-lg">Select Agent For Showing</button>
                                    <button className="btn btn-outline-dark btn-lg">Message Agent</button>
                                </div>
                                <div className="mt-3">
                                    <small>Make a winning offer with the help of a local agent</small>
                                </div>
                                <hr />
                                <div className="text-center">
                                    <div>Ask a question</div>
                                    <a href="tel:8477448075" className="fw-bold text-decoration-none">(847) 744-8075</a>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <SeoFooter />
        </>
    );
}